import appApi from '../../app-api';
import { HttpStatusCode } from 'axios';
import { toast } from 'react-toastify';
import { FileUploadFile } from 'primereact/fileupload';
import globalConfigStore from '../../../stores/global-config-store';

export const uploadFileAndRetrieveFileUrl = async (
  preSignUrl: string,
  file: FileUploadFile,
) => {
  try {
    const url = preSignUrl;
    const urlWithoutQueryParams = url.split('?')[0];

    // Use the URL object to extract just the path
    const parsedUrl = new URL(urlWithoutQueryParams);
    const path = parsedUrl.pathname;

    const fullUrl = `${globalConfigStore.baseFileUrl}${path}`;

    const uploadFileRes = await appApi.uploadFile(url, file);
    if (uploadFileRes.status !== HttpStatusCode.Ok) {
      throw new Error('Upload file is failed');
      toast.error('העלאת הקובץ נכשלה, יש לנסות שוב בעוד מספר רגעים...');
    }
    return fullUrl;
  } catch (e) {
    console.error(
      `uploadFileAndRetrieveFileUrl is failed with the preSignUrl: ${preSignUrl} with the error: ${e}`,
    );
  }
};
